// Angular
import { Component, OnInit, Input } from '@angular/core';

// Data/Classes/Interface/Others
import { VoucherIFace, UserCls } from 'src/app/shared/classes';

@Component({
  selector: 'app-voucher-show',
  templateUrl: './voucher-show.component.html',
  styleUrls: ['./voucher-show.component.less']
})
export class VoucherShowComponent implements OnInit {
  @Input() voucher: VoucherIFace;
  @Input() allUsers: Array<UserCls>;

  public voucherData = {
    code: '',
    date: '',
    discount: '',
    expired: '',
    extendYear: '',
    isTraining: false,
    count: '',
    whoRedeem: [],
    status: '',
    category: '',
    totalCount: '',
    subscription_type:'',
    duration : '',
    account_type:'',
    plan_type:''
  };

  constructor() { }

  ngOnInit() {
    this.setUpVoucherData();
  }

  private setUpVoucherData() {
    this.voucherData.code = this.voucher.data.code;
    this.voucherData.date = this.voucher.data.date;
    this.voucherData.expired = this.voucher.data.expired;
    this.voucherData.extendYear = this.voucher.data.extendYear;
    this.voucherData.count = this.voucher.data.count;
    this.voucherData.discount = this.voucher.data.discount;
    this.voucherData.isTraining = this.voucher.data.isTraining;
    this.voucherData.status = this.voucher.data.status;
    this.voucherData.category = this.voucher.data.category;
    this.voucherData.subscription_type = this.voucher.data.subscription_type;
    this.voucherData.duration = this.voucher.data.duration;
    this.voucherData.account_type = this.voucher.data.account_type || "beginner";
    this.voucherData.plan_type = this.voucher.data.plan_type || "N/A"
    
    this.voucherData.totalCount = this.voucher.data.totalCount !== 0 ? String(this.voucher.data.totalCount) : 'N/A';

    this.findWhoRedeemed();
  }

  // find who redeemed the voucher
  private findWhoRedeemed() {
    this.voucherData.whoRedeem = this.allUsers.filter(element => {
      const subscription = JSON.parse(element.subscription);

      if (subscription !== null && subscription.hasOwnProperty('account')) {
        const voucherCode = subscription.account.voucher_code;

        return voucherCode === this.voucherData.code;
      }
    });
  }
}
